import { Component, inject, Inject, Input, OnChanges, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { codeableConceptDataType, FormFields, formMetaData, GroupField, IndividualField, SingleCodeField } from '../../shared/dynamic-forms.interface2';
import { DynamicFormsV2Component } from "../../shared/dynamic-forms-v2/dynamic-forms-v2.component";
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { FormArray, FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddVitalsComponent } from "../add-vitals/add-vitals.component";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpClient } from '@angular/common/http';
import { catchError, EMPTY, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { Observation, ServiceRequest } from 'fhir/r4';
import { SplitHashPipe } from "../../shared/split-hash.pipe";
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { commonImports } from '../../shared/table-interface';
import { EncounterServiceService } from '../../patient-wrapper/encounter-service.service';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { StateService } from '../../shared/state.service';
import { backendEndPointToken } from '../../app.config';
import { ErrorService } from '../../shared/error.service';
import { CacheStorageService } from '../../cache-storage.service';
import { AuthService } from '../../shared/auth/auth.service';
import { FhirResourceService } from '../../shared/fhir-resource.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessMessageComponent } from '../../shared/success-message/success-message.component';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { FhirResourceTransformService } from '../../shared/fhir-resource-transform.service';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { referenceArrayContains, referenceMatches } from '../../shared/fhir-reference.util';
import { ObservationFinalizationService } from '../../shared/observation-finalization.service';
import { ResourceRefreshService } from '../../shared/resource-refresh.service';
import { SuccessToastService } from '../../shared/success-toast.service';

@Component({
  selector: 'app-add-observation',
  imports: [DynamicFormsV2Component,
    MatInputModule, MatFormFieldModule, MatAutocompleteModule,
    AsyncPipe, TitleCasePipe, MatIconModule, MatButtonModule, ReactiveFormsModule,
    MatChipsModule, MatCardModule, AddVitalsComponent, SplitHashPipe],
  templateUrl: './add-observation.component.html',
  styleUrl: './add-observation.component.scss'
})
export class AddObservationComponent {
  data: any = inject(MAT_DIALOG_DATA, { optional: true });
  backendEndPoint = inject(backendEndPointToken);
  observationCodeSelectData: Observable<any[]> = of([]);
  fb = inject(FormBuilder);
  errorService = inject(ErrorService);

  physicalExamForm = this.fb.group({
    // Define your form controls here
    examArray: this.fb.array([]),

  });
  get examArray() {
    return this.physicalExamForm.get('examArray') as FormArray;
  }

  addToExamArray() {
// $#$    // /* alert("adding"); */
    this.examArray.push(this.fb.group({
      'name': ['', [Validators.required]],
      'value': ['', [Validators.required]]
    }));
  }

  displayConceptFieldDisplay(conceptField: any): string {
    return conceptField?.display || String(conceptField);
  }
  currentExamSearchValue = new FormControl("");
  observationNameChosen = new FormControl("");
  dialog = inject(MatDialog);


  http = inject(HttpClient);
  sv(event: any) {
    console.log(event.source._value);

    if (event.selected) {
// $#$      // /* alert(JSON.stringify(event.source._value) */)s
      this.observationNameChosen.setValue(event.source._value)
    }
    if (!event.selected) {
      const index = this.examArray.controls.findIndex(ctrl => ctrl.get(['name'])?.value === event.source._value);
      if (index !== -1) {
        this.examArray.removeAt(index);
      }

    }
  }
  labsName = new FormControl("");
  setLabsName(event: any) {
// $#$    // /* alert("i am called") */
    // console.log(event.source._value);
    if (event.value) {
      this.labsName.setValue(event.value)
    }
  }
  ngOnInit() {
// $#$    // /* alert("init"); */

    //PUT our website name as default system for the elements in the two array above

    const defaultSystem = this.backendEndPoint;

    this.samplePhysicalExaminationObservations = this.samplePhysicalExaminationObservations.map(item => ({
      ...item,
      system: defaultSystem
    }));
    this.sampleLaboratoryObservations = this.sampleLaboratoryObservations.map(item => ({
      ...item,
      system: defaultSystem
    }));



    this.labsName.valueChanges.subscribe((value: any) => {
      console.log(value);
      if (!this.isAddLabCalled && this.observationCategory.value === 'laboratory' && !this.existingObservation?.code) {
        this.isAddLabCalled = true;

        this.addLab(value.display || value || '', this.sampleLaboratoryObservations.find((item: any) => {
          if (typeof value == 'object') {
            return false;
          }
          console.log(value?.split('$#$')?.[1]);
          //  ( && value?.split('$#$').length > 0 ? value?.split('$#$')[1].trim().toLowerCase() : value?.trim().toLowerCase()))
          return item.display.trim().toLowerCase() ===
            (value?.split('$#$')?.length && value?.split('$#$')?.length > 1 ? value?.split('$#$')?.[1]?.trim().toLowerCase() : value?.trim().toLowerCase())
        }
        )?.unit || '')
      }
    });

    if (this.data && this.data.observationCategoryValue === 'laboratory') {
      // Only prefill from an existing placeholder observation. Do not force SR code,
      // because a single ServiceRequest can legitimately result in multiple observations.
      const existingCode = this.existingObservation?.code;
      if (existingCode) {
        this.labsName.setValue((existingCode as any)?.coding?.[0] || (existingCode as any)?.text || '');
      }
    }

    this.observationNameChosen.valueChanges.subscribe((value: any) => {

      const dref = this.dialog.open(ExamValueFormComponent, {
        maxHeight: '90vh',
        maxWidth: '650px',
        data: {
          name: value,
          placeholder: this.samplePhysicalExaminationObservations.find((item: any) => {
            // console.log(value?.split('$#$')[1]);
            //  ( && value?.split('$#$').length > 0 ? value?.split('$#$')[1].trim().toLowerCase() : value?.trim().toLowerCase()))
            return item.display.trim().toLowerCase() === (value?.display?.trim().toLowerCase() || "");
            // (value?.split('$#$').length && value?.split('$#$').length > 1 ? value?.split('$#$')[1].trim().toLowerCase() : value?.trim().toLowerCase())
            // }
            // return true
          }
          )?.placeholder || 'Enter value'
        }
      })
      dref.afterClosed().subscribe(result => {
        if (result) {
          // console.log(this.examArray.controls[0].get(['value']), this.examArray.controls[0].get(['value'])?.value);
          // if (this.examArray.controls[0].get(['value'])?.value) {

          this.addToExamArray();
          this.examArray.controls[this.examArray.controls.length - 1]?.get(['name'])?.setValue(value);
          this.examArray.controls[this.examArray.controls.length - 1]?.get(['value'])?.setValue(result);
          // } else {
          //   this.examArray.controls[0]?.get(['value'])?.setValue(result);
          //   this.examArray.controls[0]?.get(['name'])?.setValue(value);
          //   for (const ff of this.examArray.controls) {
          //     console.log(ff.get(['value'])?.value);
          //     console.log(ff.get(['name'])?.value);
          //   }
          //   this.physicalExamForm.get('examArray')?.updateValueAndValidity();
          // }
          console.log(this.physicalExamForm.value);
        }
      });
    })
  }
  searchCodeableConceptFromBackEnd(fieldApiName: string, value: string) {
    if (value.trim() !== "") {
      const url = "https://r4.ontoserver.csiro.au/fhir/ValueSet/$expand?url=http://terminology.hl7.org/ValueSet/snomed-intl-gps&_format=json";
      this.observationCodeSelectData = this.http.get(`${url}&filter=${value.trim()}`).pipe(
        map((data: any) => {
          return data.expansion?.contains?.length > 0 ? [

            ...data.expansion.contains
            // .map((item: any) => {
            //   return `${item.code}$#$${item.display}$#$${item.system}`;
            // }
            // )
            , {
              code: value,
              display: value,
              placeholder: value,
              system: `${this.backendEndPoint}`

            }] : [{
              code: value,
              display: value,
              placeholder: value,
              system: `${this.backendEndPoint}`

            }];
        }),
        catchError(() => {
          this.errorService.openandCloseError("Error fetching options from backend. You can leave the one you entered or try again.");
          return of([{
            code: value,
            display: value,
            placeholder: "Enter A Value",
            system: `${this.backendEndPoint}`
          }])
        })
      )
    }
  }
  
  private readonly observationFinalization = inject(ObservationFinalizationService);
  private resourceRefresh = inject(ResourceRefreshService);

  samplePhysicalExaminationObservations: any[] =
    [
      {
        "code": "301898006",
        "display": "Heart sounds",
        "placeholder": "Normal / Murmur / Irregular"
      },
      {
        "code": "249366005",
        "display": "Lung sounds",
        "placeholder": "Clear / Wheeze / Crackles"
      },
      {
        "code": "163033001",
        "display": "Abdominal tenderness",
        "placeholder": "Present / Absent / Localized"
      },
      {
        "code": "301354004",
        "display": "Edema",
        "placeholder": "None / Mild / Moderate / Severe"
      }

    ]
  sampleLaboratoryObservations = [
    {
      "code": "718-7",
      "display": "Hemoglobin [Mass/volume] in Blood",
      "unit": "g/dL"
    },
    {
      "code": "4548-4",
      "display": "Hemoglobin A1c/Hemoglobin.total in Blood",
      "unit": "%"
    },
    {
      "code": "2345-7",
      "display": "Glucose [Mass/volume] in Serum or Plasma",
      "unit": "mg/dL"
    },
    {
      "code": "2160-0",
      "display": "Creatinine [Mass/volume] in Serum or Plasma",
      "unit": "mg/dL"
    },
    {
      "code": "2951-2",
      "display": "Sodium [Moles/volume] in Serum or Plasma",
      "unit": "mmol/L"
    }
  ];


  @Input() isAnyCategory = true;
  @Input() observationCategoryValue = "";

  observationCategory = new FormControl("");
  serviceRequest?: ServiceRequest;
  dialogPatientId?: string | null;
  existingObservation?: Observation;
  enforcePaymentForFinal = false;
  paymentBalanced = false;

  private hideLabStatusField = false;

  formFields: any;
  toPassIntoDynamicForms: any;

  ngOnChanges() {
    if (this.observationCategoryValue) {
      this.observationCategory.setValue(this.observationCategoryValue);
    }

  }

  generalObsCategory = [
    {
      "code": "vital-signs",
      "display": "Vital Signs"
    },
    {
      "code": "exam",
      "display": "Exam"
    },
    // {
    //   "code": "laboratory",
    //   "display": "Laboratory"
    // },
    {
      "code": "others",
      "display": "Others"
    },
    // {
    //   "code": "survey",
    //   "display": "Survey"
    // },

    // {
    //   "code": "therapy",
    //   "display": "Therapy"
    // },
    // {
    //   "code": "activity",
    //   "display": "Activity"
    // },
    // {
    //   "code": "social-history",
    //   "display": "Social History"
    // }
  ]


  forcedStatusValue?: string;

  formMetaData =
    <formMetaData>{
      formName: 'Observations / Tests Results',
      formDescription: "Record your Observations or Test Results here",
      submitText: 'Submit',
    };
  isAddLabCalled = false;
  constructor() {
    //forceStatusValue

// $#$    // /* alert(Object.keys(data || {}) */.join(','));

// $#$    // /* alert(JSON.stringify(data) */);
    const data = this.data;
    if (data && data.observationCategoryValue) {
      this.observationCategory.setValue(data.observationCategoryValue);
      this.observationCategoryValue = data.observationCategoryValue;
    }
    if (data && data.hasOwnProperty('isAnyCategory')) {
      this.isAnyCategory = data.isAnyCategory;
// $#$      // /* alert(this.isAnyCategory); */
    }
    if (data && data.forceStatusValue) {
      this.forcedStatusValue = data.forceStatusValue;
    }

    if (data && data.hideLabStatusField === true) {
      this.hideLabStatusField = true;
    }

    if (data && data.formFields) {
// $#$      // /* alert("hey"); */
      this.formFields = data.formfields;

    }
    console.log(data);
    if (data?.serviceRequest) {
      this.serviceRequest = data.serviceRequest;
      //SET CATEGORY BASED ON SR
      if (this.serviceRequest?.category && this.serviceRequest.category.length > 0) {
        const catCoding = this.serviceRequest.category[0].coding;
        if (catCoding && catCoding.length > 0) {
          const catCode = catCoding[0].code;
          this.observationCategory.setValue(catCode || 'others');
// $#$          // /* alert(JSON.stringify(this.existingObservation) */);
          // if(!this.existingObservation?.code) {
          if (!this.isAddLabCalled) {
            this.isAddLabCalled = true;
            this.addLab()
          }
          // }
        }
      }
    }
    if (data?.patientId) {
      this.dialogPatientId = data.patientId;
    }
    if (data?.existingObservation) {
      this.existingObservation = data.existingObservation as Observation;
    }
    if (data?.enforcePaymentForFinal === true) {
      this.enforcePaymentForFinal = true;
      this.paymentBalanced = data?.paymentBalanced === true;
    }
    //  data: {
    //         formFields: [[
    //           'category', {
    //             formfields:
    //               <FormFields[]>[
    if (data && !data.chosenFields && !data.isAnyCategory &&

      (this.observationCategory.value !== 'vital-signs' &&
        this.observationCategory.value !== 'laboratory'
        && this.observationCategory.value !== 'exam') && !this.serviceRequest
    ) {
      this.toPassIntoDynamicForms = [];
      this.data.observationformFields.forEach((element: [string, {
        [key: string]: any[]
      }]) => {
        if (element[0] == 'category') {
          if (element[1]['data'] && element[1]['data'].length == 1 && element[1]['data'][0].code === 'vital-signs') {
            this.observationCategory.setValue("vital-signs")
          } else if (element[1]['data'] && element[1]['data'].length == 1 && element[1]['data'][0].code === 'exam') {
            this.observationCategory.setValue("exam")
          } else if (element[1]['data'] && element[1]['data'].length == 1 && element[1]['data'][0].code === 'laboratory') {
            this.observationCategory.setValue("laboratory")
          }
        }
        console.log(element, element[1], element[1]['formFields'])
        this.toPassIntoDynamicForms = [...this.toPassIntoDynamicForms, ...element[1]['formFields']]
      });

      console.log(this.toPassIntoDynamicForms);
    }
  }
  sn = inject(MatSnackBar);
  setObsCat(event: any) {
    if (event && event.value) {
      this.observationCategory.setValue(event.value)
      this.isAnyCategory = false;
    }
    if (this.observationCategory.value !== 'laboratory'
      && this.observationCategory.value !== 'exam'
      && this.observationCategory.value !== 'vital-signs'


    ) {
      this.ecServ.addObservation('100001', null, this.dref, this.observationCategory.value);
    }
  }
  ecServ = inject(EncounterServiceService);

  formFieldsDataService = inject(FormFieldsSelectDataService);
  labFormFields?: any[];
  labFormMetaData: formMetaData = {
    formName: 'Add Laboratory Result',
    formDescription: "Add a new laboratory result",
    submitText: 'Submit Result',
    showSubmitButton: true,
    closeDialogOnSubmit: false,


  };

  logger: {
    [key: string]: any
  } = {}
  frs = inject(FhirResourceService);
  postToBackend(event: any) {
    // Validate patient and encounter (encounter optional unless required by your flow)
    const patientId = this.stateService.PatientResources.currentPatient.value.actualResource?.id;
    if (!patientId) {
      this.errorService.openandCloseError('No current patient selected.');
      return;
    }

    // Basic validation: require name/code and status
    const nameOk = !!event?.name;

    const statusOk = !!event?.status;
    const valueObj = event?.value || {};
    if (!nameOk || !statusOk) {
      this.errorService.openandCloseError('Please provide Observation name and status.');
      return;
    }

    // Build Observation resource from form payload
    const observation = this.buildObservationFromForm(event);

    // POST to backend; prefer full representation back
    this.http.post(`${this.backendEndPoint}/Observation`, observation, {
      headers: { 'Content-Type': 'application/fhir+json', 'Accept': 'application/fhir+json', 'Prefer': 'return=representation' }
    }).subscribe({
      next: (resp: any) => {
        const saved = resp?.resourceType === 'OperationOutcome' ? observation : (resp || observation);
        // Persist in state as saved if id present, else unsaved
        this.stateService.persistLocalResource(saved, saved?.id ? 'saved' : 'unsaved');

        // success snackbar
        this.sn.openFromComponent(SuccessMessageComponent, {
          data: 'Observation saved successfully!',
          duration: 3000,
        });
        this.cacheStorage.clearCacheForResource('Observation');
        try {
          this.resourceRefresh.notify('patient-observation', { full: true });
        } catch (e) { }
        this.dref?.close(saved);
      },
      error: (err) => {
        console.error('Failed to post observation:', err);
        // Persist locally as unsaved
        // this.stateService.persistLocalResource(observation, 'unsaved');
        this.errorService.openandCloseError('Failed to post observation');

        // Stored locally.');
      }
    });
  }
  observation_status = [
    "registered",
    "preliminary",
    "final",
    "amended",
    "corrected",
    "cancelled",
    "entered-in-error",
    "unknown"
  ]

  observation_units = [
    "kg",     // kilograms
    "g",      // grams
    "mg",     // milligrams
    "ug",     // micrograms
    "L",      // liters
    "mL",     // milliliters
    "cm",     // centimeters
    "mm",     // millimeters
    "m",      // meters
    "mmHg",   // millimeters of mercury (blood pressure)
    "bpm",    // beats per minute (heart rate)
    "/min",   // per minute (respiration rate)
    "°C",     // degrees Celsius (body temperature)
    "%",      // percent (e.g., oxygen saturation)
    "mol/L",  // moles per liter (common for electrolytes)
    "mmol/L", // millimoles per liter (common for glucose, cholesterol)
    "mg/dL",  // milligrams per deciliter
    "ng/mL",  // nanograms per milliliter
    "U/L",    // units per liter (e.g., liver enzymes)
    "IU/L",   // international units per liter
    "mEq/L",  // milliequivalents per liter
    "cm[H2O]",// centimeters of water (respiratory pressure)
    "s",      // seconds
    "min",    // minutes
    "h",      // hours
    "d"       // days
  ]
  addLab(display?: string, unit?: string) {
    this.labFormMetaData.formName = `Add  Result For  ${display ||
      this.serviceRequest?.code?.coding?.[0]?.display ||
      this.serviceRequest?.code?.text
      || this.serviceRequest?.category?.[0]?.coding?.[0]?.display ||
      this.serviceRequest?.category?.[0]?.text || 'Laboratory Observation'

      }`;
    forkJoin({
      practitioner: this.formFieldsDataService.getFormFieldSelectData('observation', 'practitioner'),
      localCode: this.formFieldsDataService.getFormFieldSelectData('observation', 'localCode')

    }).subscribe((g: any) => {
      console.log(g);

      this.labFormFields = <FormFields[]>[
        ...(this.existingObservation ? [] : [
          <FormFields>{
            generalProperties: {
              fieldApiName: 'code',
              fieldName: 'Name of Observation / Test',
              fieldHint: 'Pick from suggested names or enter your own',
              fieldLabel: 'Name of Observation / Test',
              allowedOthers: true,
              fieldType: 'CodeableConceptField',
              isArray: false,
              isGroup: false
            },
            data: g.localCode
          }
        ]),

        <SingleCodeField>{
          generalProperties: {
            fieldApiName: 'status',
            fieldName: 'Observation Status',
            fieldLabel: 'Observation Status',
            fieldType: 'SingleCodeField',
            isArray: false,
            isGroup: false,
            isHidden: this.hideLabStatusField,
            value: this.existingObservation?.status ?? "preliminary",
            // value: (this.existingObservation?.status || (this.paymentBalanced ? 'final' : 'registered')),
            validations: [{ type: 'default', name: 'required' }]
          },
          data: ['registered', 'preliminary', 'final']
        },

        <GroupField>{


          groupFields: {
            'result_type': <SingleCodeField>{

              generalProperties: {

                fieldApiName: 'result_type',
                fieldName: 'Type of Result',
                fieldLabel: 'Type of Result',
                // value: category === "category3" ? 'Text' : '',
                controllingField: [{
                  isAControlField: true,
                  dependentFieldVisibilityTriggerValue: 'Text',
                  controlledFieldDependencyId: "result_type.text"

                },
                {
                  isAControlField: true,
                  dependentFieldVisibilityTriggerValue: 'Number',
                  controlledFieldDependencyId: "result_type.number2"

                },

                {
                  isAControlField: true,
                  controlledFieldDependencyId: "result_type.number",
                  dependentFieldVisibilityTriggerValue: 'Number'
                }],
                fieldType: 'SingleCodeField',
                isArray: false,
                isGroup: false
              },
              data: ['Number', 'Text']

            },
            'result_value': <IndividualField>{
              generalProperties: {

                fieldApiName: 'result_value',
                fieldName: 'Result Value',
                fieldLabel: 'Result Value',
                inputType: 'number',
                dependence_id: 'result_type.number',
                fieldType: 'IndividualField',
                isArray: false,
                isGroup: false
              },


            },

            'result_value_text': <IndividualField>{
              generalProperties: {

                fieldApiName: 'result_value',
                fieldName: 'Result ',
                fieldLabel: 'Result ',
                inputType: 'textarea',
                dependence_id: 'result_type.text',
                fieldType: 'IndividualField',
                isArray: false,
                isGroup: false
              },


            },

            'result_unit': <IndividualField>{

              generalProperties: {

                fieldApiName: 'result_unit',
                fieldName: 'Unit',
                fieldLabel: 'Unit',
                fieldHint: 'Pick from suggested units or enter your own',
                dependence_id: 'result_type.number2',
                fieldType: 'SingleCodeField',
                isArray: false,
                isGroup: false
              },
              data: this.observation_units

            },


          },
          keys: [
            ''
          ],
          generalProperties: {

            fieldApiName: 'value',
            fieldName: 'Result',//category === "category3" ? 'Observation Results' : 'Observation / Test Results',
            fieldLabel: 'Result',//category === "category3" ? 'Observation Results' : 'Observation / Test Results',
            fieldType: 'SingleCodeField',
            isArray: false,
            isGroup: true
          },


        },

        // <IndividualField>{
        //   generalProperties: {

        //     fieldApiName: 'attachment',
        //     fieldName: 'Add an Attachment',
        //     fieldLabel: 'Add an Attachment',
        //     fieldType: 'IndividualField',
        //     isArray: false,
        //     isGroup: false,
        //     inputType: 'photo_upload'
        //   },
        //   data: ''
        // },




      ]

      // Prefill value fields from an existing placeholder observation (if any)
      const existing = this.existingObservation as any;
      if (this.labFormFields?.[1]?.groupFields) {
// $#$        // /* alert(JSON.stringify(existing) */);
        // NOTE: both the numeric and text UI fields currently share the same fieldApiName ('result_value'),
        // so there is only one underlying FormControl. Prefill must target that control.
        if (existing?.valueQuantity && existing.valueQuantity.value) {
          this.labFormFields[1].groupFields['result_type'].generalProperties.value = 'Number';
          this.labFormFields[1].groupFields['result_value'].generalProperties.value = String(existing.valueQuantity.value ?? '');
          this.labFormFields[1].groupFields['result_unit'].generalProperties.value = existing.valueQuantity.unit || unit || '';
        } else if (existing?.valueString) {
          this.labFormFields[1].groupFields['result_type'].generalProperties.value = 'Text';
          this.labFormFields[1].groupFields['result_value'].generalProperties.value = String(existing.valueString ?? '');
        }
      }

    })

  }

  private cleanupObservationValueChoiceForEdit(target: any, preferred: 'quantity' | 'string'): void {
    if (!target || typeof target !== 'object') return;
    // Only clean up the common lab value choices we use here.
    if (preferred === 'quantity') {
      delete target.valueString;
    } else {
      delete target.valueQuantity;
    }
  }

  // Helper to parse "code$#$display$#$system"
  private parseExamConcept(raw: string): { code: string; display: string; system: string } {
    if (!raw) return { code: '', display: '', system: '' };
    const parts = raw.split('$#$');
    return {
      code: parts[0] || raw,
      display: parts[1] || parts[0] || raw,
      system: parts[2] || 'http://snomed.info/sct'
    };
  }
  private readonly successToast = inject(SuccessToastService);
  private readonly cacheStorage = inject(CacheStorageService);
  // private fb = inject(FormBuilder);
  stateService = inject(StateService);
  auth = inject(AuthService);
  onSubmitPhysicalExamForm() {
    if (this.physicalExamForm.invalid || this.examArray.length === 0) return;
    const encounterRef = this.stateService.getCurrentEncounterReference();
    const patientRef = this.stateService.getPatientReference();
    const performer = this.stateService.getPractitionerReference(this.auth.user?.getValue()?.['fhirResourceId']);

    const observations = this.examArray.controls.map(ctrl => {
      const rawName = ctrl.get('name')?.value || '';
      const rawValue = ctrl.get('value')?.value;
      const { code, display, system } = rawName;
      const numeric = rawValue !== null && rawValue !== '' && !isNaN(Number(rawValue));
      const obs: any = {
        resourceType: 'Observation',
        status: 'final',
        category: [{
          coding: [{
            system: 'http://terminology.hl7.org/CodeSystem/observation-category',
            code: 'exam',
            display: 'Exam'
          }]
        }],
        code: {
          coding: [{ system, code, display }],
          text: display
        },
        effectiveDateTime: new Date().toISOString()
      };
      if (encounterRef) obs.encounter = encounterRef;
      if (patientRef) obs.subject = patientRef;
      if (performer) obs.performer = [performer];

      if (numeric) {
        obs.valueQuantity = {
          value: Number(rawValue),
          unit: '',
          system: 'http://unitsofmeasure.org',
          code: ''
        };
      } else {
        obs.valueString = String(rawValue);
      }
      return obs;
    });

    // Build transaction bundle
    const txBundle = {
      resourceType: 'Bundle',
      type: 'transaction',
      entry: observations.map(o => ({
        resource: o,
        request: { method: 'POST', url: 'Observation' }
      }))
    };

    // POST bundle to server; prefer full resource representations in response
    this.http.post(`${this.backendEndPoint}`, txBundle, {
      headers: { Prefer: 'return=representation' }
    }).subscribe({
      next: (resp: any) => {
        // Normalize response to ensure entry[].resource exists.
        const respEntries = Array.isArray(resp?.entry) ? resp.entry : [];
        const normalized = {
          resourceType: 'Bundle',
          type: 'transaction',
          entry: respEntries.length
            ? respEntries.map((e: any, i: number) => {
              let resource = e.resource;
              if (!resource) {
                // Try to derive id from response.location like "Observation/{id}/_history/1"
                const loc: string = e?.response?.location || '';
                const match = loc.match(/Observation\/([^\/\s]+)/);
                const id = match && match[1] ? match[1] : undefined;
                resource = id ? { ...observations[i], id } : observations[i];
              }
              return { resource };
            })
            : observations.map(o => ({ resource: o })) // fallback (unsaved) if server didn't return entries
        };
        this.stateService.processBundleTransaction(normalized as any);

        this.cacheStorage.clearCacheForResource('Observation');

        // Reset form
        this.physicalExamForm.reset();
        while (this.examArray.length) this.examArray.removeAt(0);
        if(this.dref){
          this.dref.close(true);
        }
      },
      error: (err) => {
        console.error('Failed to save Observations (transaction):', err);
        this.errorService.openandCloseError('Failed to save observations. Please try again.');
      }
    });
  }

  removeExam(index: number) {
    if (index > -1 && index < this.examArray.length) {
      this.examArray.removeAt(index);
    }
  }

  // MatDialogRef to close this dialog programmatically
  dref = inject(MatDialogRef<AddObservationComponent>, { optional: true });

  close() {
    this.dref?.close();
  }

  // Convert "code$#$display$#$system" or plain string/object to CodeableConcept
  private toCodeableConcept(input: any): any | null {
    if (!input) return null;
    if (typeof input === 'string') {
      const s = input.trim();
      if (!s) return null;
      if (s.includes('$#$')) {
        const [code = '', display = '', system = ''] = s.split('$#$');
        return {
          coding: [{ code: code.trim(), display: display.trim(), system: system.trim() }],
          text: display || code
        };
      }
      return { text: s };
    }
    if (Array.isArray(input)) {
      const coding = input.flatMap((v: any) => {
        if (typeof v === 'string' && v.includes('$#$')) {
          const [code = '', display = '', system = ''] = v.split('$#$');
          return [{ code: code.trim(), display: display.trim(), system: system.trim() }];
        }
        if (v && typeof v === 'object' && (v.code || v.display)) {
          return [{ code: v.code || '', display: v.display || v.text || '', system: v.system || '' }];
        }
        return [];
      });
      return coding.length ? { coding, text: coding[0].display || coding[0].code } : null;
    }
    if (typeof input === 'object') {
      if (Array.isArray(input.coding)) return input;
      if (input.code || input.display) {
        return { coding: [{ code: input.code || '', display: input.display || input.text || '', system: input.system || '' }], text: input.display || input.code };
      }
    }
    return null;
  }

  // Build Observation resource from form event payload
  private buildObservationFromForm(evt: any): any {
    const nowIso = new Date().toISOString();
    const status = (evt?.status || 'preliminary').toString().trim().toLowerCase();
    const categoryCC = this.toCodeableConcept(evt?.category);
    const codeCC = this.toCodeableConcept(evt?.name || this.labsName.value);
    const encounterRef = this.stateService.getCurrentEncounterReference();
    const performer = this.stateService.getPractitionerReference(this.auth.user?.getValue()?.['fhirResourceId']);

    const obs: any = {
      resourceType: 'Observation',
      status,
      effectiveDateTime: nowIso
    };

    const categoryConcept = categoryCC || this.getDefaultCategoryConcept();
    if (categoryConcept) {
      obs.category = [categoryConcept];
    }

    const preferredCode = this.getPreferredObservationCode(codeCC);
    if (preferredCode) {
      obs.code = preferredCode;
    }

    if (this.serviceRequest?.id) {
      obs.basedOn = [{ reference: `ServiceRequest/${this.serviceRequest.id}` }];

    }

    const subjectReference = this.resolveSubjectReference();
    if (subjectReference) {
      obs.subject = subjectReference;
    }

    if (encounterRef) obs.encounter = encounterRef;
    if (performer) obs.performer = [performer];

    if (obs.code && obs.code.coding) {
      const systemUri = obs.code.coding[0].system;
      if (systemUri && !systemUri.startsWith('http')) {
        obs.code.coding[0].system = `http://${systemUri}`;
      }
    }

    // Map value group -> valueQuantity or valueString
    const v = evt?.value || {};
    const rType = (v?.result_type || '').toString().trim();
    const rVal = v?.result_value;
    const rUnit = v?.result_unit;

    const hasNumber = rVal !== undefined && rVal !== null && rVal !== '' && !isNaN(Number(rVal));
    if (rType === 'Number' && hasNumber) {
      obs.valueQuantity = {
        value: Number(rVal),
        unit: rUnit || undefined,
        system: 'http://unitsofmeasure.org',
        code: rUnit || undefined
      };
    } else if (rVal !== undefined && rVal !== null && String(rVal).trim() !== '') {
      obs.valueString = String(rVal).trim();
    }

    // Optional valueAttachment from 'attachment' control (first item)
    const att = evt?.attachment;
    const first = Array.isArray(att) ? att[0] : att;
    if (first && (first.data || first.url)) {
      obs.valueAttachment = {
        contentType: first.type || first.contentType || 'application/octet-stream',
        data: first.data, // base64
        url: first.url,
        title: first.name || first.title
      };
    }

    // Subject, encounter, performer from state/auth
    const patientRef = this.stateService.getPatientReference();
    // const encounterRef = this.stateService.getCurrentEncounterReference();
    const performerRef = this.stateService.getPractitionerReference(this.auth.user?.getValue()?.['fhirResourceId']);

    if (patientRef) obs.subject = patientRef;
    if (encounterRef) obs.encounter = encounterRef;
    if (performerRef) obs.performer = [performerRef];

    return obs;
  }

  private getPreferredObservationCode(formCode: any): any | null {
    return this.serviceRequest?.code ?? formCode;
  }

  private getDefaultCategoryConcept(): any | null {
    if (this.observationCategory.value === 'laboratory') {
      return {
        coding: [{
          system: 'http://terminology.hl7.org/CodeSystem/observation-category',
          code: 'laboratory',
          display: 'Laboratory'
        }]
      };
    }
    return null;
  }

  private resolveSubjectReference(): any | null {
    if (this.data?.subject) return this.data.subject;
    if (this.serviceRequest?.subject) return this.serviceRequest.subject;
    if (this.dialogPatientId) {
      return { reference: `Patient/${this.dialogPatientId}` };
    }
    return this.stateService.getPatientReference();
  }
  fhirresourceTransformService = inject(FhirResourceTransformService);

  private normalizeCodeableConceptTokens(cc: any): Set<string> {
    const tokens = new Set<string>();
    const codings = (cc as any)?.coding;
    if (Array.isArray(codings)) {
      for (const c of codings) {
        const code = (c?.code || '').toString().trim();
        if (!code) continue;
        const system = (c?.system || '').toString().trim();
        tokens.add(`${system}|${code}`);
        tokens.add(`|${code}`);
      }
    }
    const text = (cc as any)?.text;
    if (typeof text === 'string' && text.trim()) {
      tokens.add(`text|${text.trim().toLowerCase()}`);
    }
    return tokens;
  }

  private codesMatch(a: any, b: any): boolean {
    if (!a || !b) return false;
    const aTokens = this.normalizeCodeableConceptTokens(a);
    const bTokens = this.normalizeCodeableConceptTokens(b);
    for (const t of aTokens) {
      if (bTokens.has(t)) return true;
    }
    return false;
  }

  private listObservationsForServiceRequest(srRef: string): Observable<Observation[]> {
    const fromState = (this.stateService.PatientResources.observations.getValue() || [])
      .map((w) => w.actualResource)
      .filter((o: any) => referenceArrayContains(o?.basedOn, srRef)) as Observation[];

    if (fromState.length) {
      return of(fromState);
    }

    const fetchByBasedOn$ = this.http
      .get<any>(`${this.backendEndPoint}/Observation?based-on=${encodeURIComponent(srRef)}&_count=200`)
      .pipe(
        map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as Observation[]),
        map((list: Observation[]) => (list || []).filter((o: any) => referenceArrayContains(o?.basedOn, srRef))),
        catchError(() => of([] as Observation[]))
      );

    const patientRef = this.resolveSubjectReference()?.reference;
    const patientId = patientRef ? patientRef.split('/')[1] : null;
    const fetchBySubject$ = patientId
      ? this.http
        .get<any>(`${this.backendEndPoint}/Observation?subject=${encodeURIComponent(`Patient/${patientId}`)}&_count=200`)
        .pipe(
          map((b: any) => (b?.entry || []).map((e: any) => e?.resource).filter(Boolean) as Observation[]),
          map((list: Observation[]) => (list || []).filter((o: any) => referenceArrayContains(o?.basedOn, srRef))),
          catchError(() => of([] as Observation[]))
        )
      : of([] as Observation[]);

    return fetchByBasedOn$.pipe(
      switchMap((list: Observation[]) => (list?.length ? of(list) : fetchBySubject$))
    );
  }

  private confirmCancelPreviousFinalObservations(conflicts: Observation[]): Observable<boolean> {
    const count = conflicts.length;
    const msg = count === 1
      ? 'There is already a FINAL result for this same lab test under this request.\n\nDo you want to cancel the previous final result and save this one as FINAL?'
      : `There are already ${count} FINAL results for this same lab test under this request.\n\nDo you want to cancel the previous final results and save this one as FINAL?`;

    const ref = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '520px',
      data: {
        title: 'Replace final result?',
        message: msg,
        confirmText: 'Yes, replace',
        cancelText: 'No, keep existing',
        icon: 'warning'
      }
    });
    return ref.afterClosed().pipe(map((v: any) => v === true));
  }

  submitLabResult(e: any) {
    // const desiredStatus = (e?.status || this.existingObservation?.status || 'final').toString().trim().toLowerCase();
    const desiredStatus = this.forcedStatusValue ? this.forcedStatusValue : (e?.status || this.existingObservation?.status || 'final').toString().trim().toLowerCase();
    // if (this.enforcePaymentForFinal && desiredStatus === 'final' && !this.paymentBalanced) {
    if (this.enforcePaymentForFinal && !this.paymentBalanced) {
      this.errorService.openandCloseError(
        'Payment has not been confirmed. You cannot start a lab test until payment is balanced.'
      );
      return;
    }

    if (e.value) {
      if (e.value.result_type === 'Number') {
        //validate
        if (isNaN(Number(e.value.result_value))) {
          this.errorService.openandCloseError('Please provide a valid numeric value for the result.');
          return;
        }
        //unit
        if (!e.value.result_unit) {
          this.errorService.openandCloseError('Please provide a unit for the numeric result.');
          return;
        }
        e.valueQuantity = {
          value: Number(e.value.result_value),
          unit: e.value.result_unit || undefined,
          system: 'http://unitsofmeasure.org',

        };

      } else {
        //text
        if (!e.value.result_value || String(e.value.result_value).trim() === '') {
          this.errorService.openandCloseError('Please provide a valid text value for the result.');
          return;
        }
        e.valueString = String(e.value.result_value).trim();
      }

    }

    if (e.attachment) {
      //       {
      //     "fileLink": "https://elikita2026kraiyxw7s2ywg.blob.core.windows.net/profile/1764175497915_PGD.pdf",
      //     "uploadFileSize": 515567,
      //     "uploadFileName": "PGD.pdf",
      //     "uploadFileType": "application/pdf",
      //     "azureBlobName": "1764175497915_PGD.pdf",
      //     "uploadDate": "2025-11-26T16:45:02.231Z"
      // }
      e.extension = [
        {
          url: 'http://example.org/fhir/StructureDefinition/observation-attachment',
          valueAttachment: {
            contentType: e.attachment[0].uploadFileType || e.attachment[0].contentType || 'application/octet-stream',
            // data: e.attachment[0].data, // base64
            url: e.attachment[0].fileLink,
          }
        }
      ]
    }
    delete e?.attachment; delete e?.value
    const nowIso = new Date().toISOString();

    // const categoryCC = this.toCodeableConcept();
    const serviceRequestData: ServiceRequest = this.data?.serviceRequest;
    const category = serviceRequestData.category ?? [{
      coding: [{
        system: 'http://terminology.hl7.org/CodeSystem/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }];
    const transformed: any = this.fhirresourceTransformService.transformValues('Observation', e);
    // IMPORTANT: do not force SR code. Prefer the form code (if provided), else existing placeholder code, else SR code.
    const code = transformed?.code || (this.existingObservation as any)?.code || serviceRequestData?.code;
    const encounter = serviceRequestData?.encounter || (this.existingObservation as any)?.encounter;
    const subject = serviceRequestData?.subject || (this.existingObservation as any)?.subject;
    const basedOn = serviceRequestData?.id
      ? [{ reference: `ServiceRequest/${serviceRequestData.id}` }]
      : ((this.existingObservation as any)?.basedOn || undefined);


    const performer = this.stateService.getPractitionerReference(this.auth.user?.getValue()?.['fhirResourceId']);

    const values: Observation = {
      ...(this.existingObservation || {}),
      ...transformed,
      code,
      encounter,
      subject,
      basedOn,
      effectiveDateTime: new Date().toISOString(),
      category,
      performer: performer ? [performer] : undefined,
      status: desiredStatus,
      resourceType: 'Observation'
    };

    // When editing, ensure we don't accidentally keep an old value[x] from the existing Observation.
    // (Spread merge will not remove old fields.)
    const isEdit = !!(this.existingObservation as any)?.id;
    if (isEdit) {
      if ((e as any)?.valueQuantity) {
        this.cleanupObservationValueChoiceForEdit(values as any, 'quantity');
      } else if ((e as any)?.valueString) {
        this.cleanupObservationValueChoiceForEdit(values as any, 'string');
      }
    }




    console.log(values);
// $#$    // /* debugger; */

    const isUpdate = !!values?.id;
    const url = isUpdate ? `${this.backendEndPoint}/Observation/${values.id}` : `${this.backendEndPoint}/Observation`;
    const save$ = isUpdate
      ? this.http.put(url, values, {
        headers: { 'Content-Type': 'application/fhir+json', 'Accept': 'application/fhir+json', 'Prefer': 'return=representation' }
      })
      : this.http.post(url, values, {
        headers: { 'Content-Type': 'application/fhir+json', 'Accept': 'application/fhir+json', 'Prefer': 'return=representation' }
      });

    const srRef = serviceRequestData?.id ? `ServiceRequest/${serviceRequestData.id}` : null;

    const preflight$ = this.observationFinalization.validateSingleFinalization$({
      serviceRequestRef: srRef,
      observationToSave: values as any
    });

    preflight$.pipe(
      switchMap((ok: boolean) => ok ? save$ : EMPTY),
      switchMap((resp: any) => {
        if (values.basedOn?.length === 0) {
          return of(resp);
        }
        if (values.status !== 'final') {
          return of(resp);
        }
        return this.changeLabRequetStatusToCompleted(values.basedOn?.[0])
          .pipe(map(() => resp));
      })
    ).subscribe({
      next: (resp: any) => {
        const saved = resp?.resourceType === 'OperationOutcome' ? values : (resp || values);
        // Persist in state as saved if id present, else unsaved
        this.stateService.persistLocalResource(saved, saved?.id ? 'saved' : 'unsaved');

        // success snackbar
        this.sn.openFromComponent(SuccessMessageComponent, {
          data: 'Lab Results saved successfully!',
          duration: 3000,
        });
        this.dref?.close(saved);
      },
      error: (err) => {
        console.error('Failed to post observation:', err);
        // Persist locally as unsaved
        // this.stateService.persistLocalResource(observation, 'unsaved');
        this.errorService.openandCloseError('Failed to post observation');

        // Stored locally.');
      }
    });

  }
  private changeLabRequetStatusToCompleted(basedOn?: { reference?: string }) {
    const serviceRequestId = this.extractServiceRequestId(basedOn?.reference);
    if (!serviceRequestId) {
      return of(null);
    }
    return this.http.patch(`${this.backendEndPoint}/ServiceRequest/${serviceRequestId}`, [
      { op: 'replace', path: '/status', value: 'completed' }
    ], {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/fhir+json',
        'Prefer': 'return=representation'
      }
    }).pipe(
      map((resp: any) => {
        if (resp && resp.resourceType && resp.resourceType !== 'OperationOutcome') {
          this.stateService.persistLocalResource(resp, 'saved');
        }
        return resp;
      }),
      catchError((err) => {
        console.error('Failed to update ServiceRequest status', err);
        this.errorService.openandCloseError('Unable to mark the lab request as completed.');
        return of(null);
      })
    );
  }

  private extractServiceRequestId(reference?: string): string | null {
    if (!reference) return null;
    const parts = reference.split('/');
    return parts.length > 1 ? parts[parts.length - 1] : null;
  }

  // Open a reusable dialog to show object details as key/value
  openRowDetails(row: any, title: string = 'Details') {
    this.dialog.open(RowDetailsDialogComponent, {
      width: '720px',
      maxHeight: '90vh',
      data: { title, row }
    });
  }

}

@Component({
  selector: 'app-value-form',
  templateUrl: './exam-value-form.html',
  imports: [...commonImports],
  styleUrls: ['./add-observation.component.scss']
})
export class ExamValueFormComponent {
  examName?: 'string';
  data: any = inject(MAT_DIALOG_DATA);
  dRef = inject(MatDialogRef<ExamValueFormComponent>);
  constructor() {
    const data = this.data;
    console.log(data);
    if (data && data.name) {

      this.examName = data.name.display ?? data.name;
      // .split("$#$").length > 1 ? data.name.split("$#$")[1] : data.name;
    }

  }

  addAndClose(value: string) {
    this.dRef.close(value);
  }

}

@Component({
  selector: 'app-row-details-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Details' }}</h2>
    <div mat-dialog-content>
      <table class="kv">
        <tbody>
          <tr *ngFor="let kv of entries">
            <th>{{ kv.key }}</th>
            <td>
              <ng-container [ngSwitch]="kv.type">
                <span *ngSwitchCase="'primitive'">{{ kv.value }}</span>
                <pre *ngSwitchDefault>{{ kv.value | json }}</pre>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
  styles: [`
    .kv { width: 100%; border-collapse: collapse; }
    .kv th { text-align: left; padding: 6px 8px; color: var(--mat-sys-on-surface-variant); width: 30%; vertical-align: top; }
    .kv td { padding: 6px 8px; }
    pre { margin: 0; white-space: pre-wrap; word-break: break-word; }
  `]
})
export class RowDetailsDialogComponent {
  entries: Array<{ key: string; value: any; type: 'primitive' | 'object' }> = [];
  data: { title?: string; row: any } = inject(MAT_DIALOG_DATA);
  constructor() {
    const data = this.data;
    const obj = data?.row || {};
    this.entries = Object.keys(obj).map(k => {
      const v = obj[k];
      const isPrimitive = v === null || ['string', 'number', 'boolean'].includes(typeof v);
      return { key: k, value: isPrimitive ? v : v, type: isPrimitive ? 'primitive' : 'object' };
    });
  }
}